import CustomButton from 'Components/CustomButton'
import CustomDialog from 'Components/CustomDialog'
import Theme from 'Util/theme'
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ThemeProvider,
  useTheme
} from '@mui/material'
import React, { useCallback, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { t } from 'ttag'

interface DialogProps {
  handleConfirm: () => void
  title: string
  message: string
}

function useConfirm() {
  const theme = useTheme()
  const [open, setOpen] = React.useState(false)
  const [content, setContent] = React.useState({
    title: '',
    message: '',
    handleConfirm: () => {
      return
    }
  })

  const handleCancel = () => {
    setOpen(false)
  }

  const _handleConfirm = () => {
    setOpen(false)
    content.handleConfirm()
  }

  useEffect(() => {
    const rootElement = document.createElement('div')
    const root = createRoot(rootElement)

    root.render(
      <ThemeProvider theme={Theme}>
        <CustomDialog open={open} handleClose={handleCancel}>
          <DialogTitle>{content.title}</DialogTitle>
          <DialogContent>
            <DialogContentText color="text.primary" sx={{ whiteSpace: 'pre-line' }}>
              {content.message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: theme.palette.text.primary }}
              onClick={handleCancel}
            >{t`No`}</Button>
            <CustomButton onClick={_handleConfirm}>{t`Yes`}</CustomButton>
          </DialogActions>
        </CustomDialog>
      </ThemeProvider>
    )

    return () => {
      setTimeout(() => {
        root.unmount()
        rootElement.parentNode?.removeChild(rootElement)
      }, 0)
    }
  }, [content, open])

  const confirm = useCallback((content: DialogProps) => {
    setContent(content)
    setOpen(true)
  }, [])
  return { confirm }
}

export { useConfirm }
